export const COURSE_IDS = ['pcba-investigador','inss','prf-administrativo','seedf-gestor-administracao','pcdf-custodia','prf-policial','pmmg','pmdf','enem'];
export function permittedCourseIds(profile) {
  if (!profile || profile.bloqueado || (profile.status && profile.status !== 'active')) return [];
  if (profile.isAdmin || profile.role === 'admin') return COURSE_IDS;
  if (Array.isArray(profile.allowedCourses)) return [...new Set(profile.allowedCourses.filter(id => typeof id==='string' && /^[a-z0-9-]{1,100}$/.test(id)))];
  return profile.materias?.length ? ['pcba-investigador'] : [];
}
